import { render } from "./SwiperSlider.vue?vue&type=template&id=325bdc99"
import script from "./SwiperSlider.vue?vue&type=script&lang=js"
export * from "./SwiperSlider.vue?vue&type=script&lang=js"

import "./SwiperSlider.vue?vue&type=style&index=0&id=325bdc99&lang=less&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B"

import exportComponent from "/opt/hafele/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__